// Configuración de APIs para Cifra Negra
//const BASE_URL = "http://192.168.1.45:9021/";
const BASE_URL = "https://miaapicifratransito02.cloudc5.com/";
const OPEN_CAGE_BASE_URL = "https://api.opencagedata.com/";
const OPEN_METEO_BASE_URL = "https://api.open-meteo.com/v1/";

// Configuración de autenticación
const AUTH_CONFIG = {
  TOKEN_KEY: 'jwt_token_cifra_negra',
  REFRESH_TOKEN_KEY: 'refresh_token_cifra_negra',
  TOKEN_EXPIRY_KEY: 'token_expiry_cifra_negra'
};

// APIs de Autenticación y Usuarios
const API_USUARIO = {
  login: `${BASE_URL}api/usuario/login/`,
  refreshToken: `${BASE_URL}api/usuario/token/refresh/`,
  registro: `${BASE_URL}api/usuario/registro/`,
  perfil: `${BASE_URL}api/usuario/perfil/`,
  listar: `${BASE_URL}api/usuario/`,
  detalle: (id) => `${BASE_URL}api/usuario/${id}/`,
  descargarTemplate: `${BASE_URL}api/usuario/descargar-template/`,
  importarExcel: `${BASE_URL}api/usuario/importar-excel/`,
};

// APIs de Categorías (Tipos de Incidencias)
const API_CATEGORIA = {
  listar: `${BASE_URL}api/categoria/`,
  crear: `${BASE_URL}api/categoria/crear/`,
  detalle: (id) => `${BASE_URL}api/categoria/${id}/`,
  actualizar: (id) => `${BASE_URL}api/categoria/${id}/actualizar/`,
  eliminar: (id) => `${BASE_URL}api/categoria/${id}/eliminar/`,
};

// APIs de Incidencias (Denuncias Ciudadanas)
const API_INCIDENCIA = {
  // Endpoints públicos (sin autenticación)
  crearAnonima: `${BASE_URL}api/incidencia/crear-anonima/`,
  detallePublico: (id) => `${BASE_URL}api/incidencia/publico/${id}/`,
  buscarPorTicket: `${BASE_URL}api/incidencia/buscar/`,
  detallePorTicket: `${BASE_URL}api/incidencia/publico/`,
  
  // Endpoints protegidos (requieren autenticación)
  listar: `${BASE_URL}api/incidencia/`,
  crear: `${BASE_URL}api/incidencia/crear/`,
  gestionar: (id) => `${BASE_URL}api/incidencia/${id}/`,
  cambiarStatus: (id) => `${BASE_URL}api/incidencia/${id}/cambiar-status/`,
  estadosDisponibles: `${BASE_URL}api/incidencia/estados/`,
  estadosPorIncidencia: (id) => `${BASE_URL}api/incidencia/${id}/estados-disponibles/`,
  estadisticas: `${BASE_URL}api/incidencia/estadisticas/`,
};

// APIs de Archivos (Fotos y Documentos)
const API_ARCHIVO = {
  upload: `${BASE_URL}api/archivo/upload/`,
  listarPorIncidencia: (incidenciaId) => `${BASE_URL}api/archivo/incidencia/${incidenciaId}/`,
  download: (archivoId) => `${BASE_URL}api/archivo/download/${archivoId}/`,
  info: (archivoId) => `${BASE_URL}api/archivo/info/${archivoId}/`,
  eliminar: (archivoId) => `${BASE_URL}api/archivo/delete/${archivoId}/`,
};

// APIs de Vías (Calles, Avenidas, etc.)
const API_VIA = {
  listar: `${BASE_URL}api/via/`,
  buscar: `${BASE_URL}api/via/buscar/`,
  detalle: (id) => `${BASE_URL}api/via/${id}/`,
  crear: `${BASE_URL}api/via/crear/`,
  actualizar: (id) => `${BASE_URL}api/via/${id}/actualizar/`,
  eliminar: (id) => `${BASE_URL}api/via/${id}/eliminar/`,
  buscarPorUbicacion: `${BASE_URL}api/via/buscar-por-ubicacion/`,
};

// APIs de Geocodificación (OpenCage)
const API_GEOCODING = {
  openCageGeocode: (lat, lng, apiKey) =>
    `${OPEN_CAGE_BASE_URL}geocode/v1/json?q=${lat}+${lng}&key=${apiKey}`,
};

// APIs de Clima (Open-Meteo - GRATUITA SIN API KEY)
const API_WEATHER = {
  // Open-Meteo: https://open-meteo.com/ - Completamente gratuita sin API key
  
  // Endpoint para obtener temperatura actual y código del clima
  currentWeather: (lat, lng) => 
    `${OPEN_METEO_BASE_URL}forecast?latitude=${lat}&longitude=${lng}&current=temperature_2m,weather_code&timezone=auto`,
  
  // Endpoint para obtener pronóstico
  forecast: (lat, lng) => 
    `${OPEN_METEO_BASE_URL}forecast?latitude=${lat}&longitude=${lng}&hourly=temperature_2m&timezone=auto`,
};

// APIs de Historial (Auditoría Automática)
const API_HISTORIAL = {
  listar: `${BASE_URL}api/historial/`,
  detalle: (id) => `${BASE_URL}api/historial/detalle/${id}/`,
  historialIncidencia: (incidenciaId) => `${BASE_URL}api/historial/incidencia/${incidenciaId}/`,
  estadisticas: `${BASE_URL}api/historial/estadisticas/`,
  crearManual: `${BASE_URL}api/historial/crear-manual/`,
};

// APIs de Notificaciones (Temporales - Simuladas)
const API_NOTIFICACIONES = {
  // WhatsApp API (Temporal - Simulada)
  whatsapp: {
    // En producción: "https://api.whatsapp.com/v1/messages"
    baseUrl: "https://api.whatsapp-simulado.com/v1/messages",
    token: "temp_whatsapp_token_12345",
    phoneNumberId: "temp_phone_id_67890",
    businessAccountId: "temp_business_id_11111"
  },
  
  // Correo Electrónico API (Temporal - Simulada)
  correo: {
    // En producción: "https://api.sendgrid.com/v3/mail/send" o similar
    baseUrl: "https://api.correo-simulado.com/v1/send",
    apiKey: "temp_correo_api_key_12345",
    fromEmail: "alertas@cifranegra.com",
    fromName: "Sistema CIFRA NEGRA"
  }
};

// Mantener compatibilidad con código existente
const API_CIFRA = {
  // Endpoint para alertas ciudadanas (público)
  alertas: API_INCIDENCIA.crearAnonima,
  alertasSearch: (documento) => `${BASE_URL}api/incidencia/buscar/?documento=${documento}`,
  
  // APIs de geocodificación
  openCageGeocode: API_GEOCODING.openCageGeocode,
  
  // APIs de notificaciones
  notificaciones: API_NOTIFICACIONES,
  
  // Exportar todas las APIs organizadas
  usuario: API_USUARIO,
  categoria: API_CATEGORIA,
  incidencia: API_INCIDENCIA,
  archivo: API_ARCHIVO,
  via: API_VIA,
  historial: API_HISTORIAL,
  geocoding: API_GEOCODING,
  weather: API_WEATHER,
  auth: AUTH_CONFIG,
};

export default API_CIFRA;
